"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const mapTextFramgent = (props, offset, fragment) => {
    const { block, renderStyle: RenderStyle, renderTextFragment: RenderTextFragment, } = props;
    const key = `${block.blockKey}-${offset}`;
    const fragmentProps = props.readOnly ? {} : {
        key,
        'data-block-key': block.blockKey,
        'data-text-fragment': true,
        'data-fragment-start': offset,
        'data-fragment-end': offset + fragment.text.length
    };
    const fragmentText = fragment.text;
    let textFragment = (fragment.styles || []).reduce((children, val) => {
        if (RenderStyle != null) {
            return React.createElement(RenderStyle, { key: `${fragmentProps.key}-${val}`, style: val }, children);
        }
        else {
            return children;
        }
    }, React.createElement("span", Object.assign({}, fragmentProps, { key: `fragment-${block.blockKey}-${offset}` }), fragmentText));
    if (RenderTextFragment) {
        textFragment = React.createElement(RenderTextFragment, { "data-text-fragment": "true", key: `block-${block.blockKey}-${offset}` }, textFragment);
    }
    return textFragment;
};
const reduceFragments = (props, _offset = 0, fragments) => {
    return fragments.reduce(({ offset, rendered }, fragment) => {
        if ('fragments' in fragment) {
            const reducedFragments = reduceFragments(props, offset + 1, fragment.fragments);
            return {
                rendered: rendered.concat([reducedFragments.rendered]),
                offset: reducedFragments.offset + 1
            };
        }
        else {
            const renderedFragment = mapTextFramgent(props, offset, fragment);
            return {
                offset: offset + fragment.text.length,
                rendered: rendered.concat([renderedFragment])
            };
        }
    }, { offset: _offset, rendered: [] });
};
function EditorText(props) {
    const { block, renderStyle: RenderStyle, renderTextFragment: RenderTextFragment, } = props;
    let textFragments = null;
    if (block.value.length > 0) {
        textFragments = reduceFragments(props, 0, block.fragments).rendered;
        console.log({ textFragments });
    }
    else {
        textFragments = React.createElement("span", { key: `text-fragments-${block.blockKey}`, "data-text-fragment": "true", "data-block-key": block.blockKey, "data-fragment-start": 0, "data-fragment-end": 0 },
            React.createElement("br", null));
    }
    return React.createElement(React.Fragment, null, textFragments);
}
exports.default = EditorText;
//# sourceMappingURL=EditorText.js.map